import { Helmet } from 'react-helmet-async';

import { Content } from './components/Content';

export const AdminSMSWhitelist = () => {
  return (
    <>
      <Helmet>
        <title>SMS OTP Phone number whitelist - AutoScript Admin</title>
      </Helmet>

      <Content />
    </>
  );
};
